export const VIDEO_POSTER_MAX_WIDTH_PX = 320;
export const VIDEO_POSTER_MAX_HEIGHT_PX = 300;
export const VIDEO_POSTER_DEFAULT_WIDTH_PX = 320;
export const VIDEO_POSTER_DEFAULT_HEIGHT_PX = 180;

export function getVideoPosterSize(width?: number, height?: number): { width: number; height: number } {
    if (!width || !height || width <= 0 || height <= 0) {
        return { width: VIDEO_POSTER_DEFAULT_WIDTH_PX, height: VIDEO_POSTER_DEFAULT_HEIGHT_PX };
    }
    const scale = Math.min(1, VIDEO_POSTER_MAX_WIDTH_PX / width, VIDEO_POSTER_MAX_HEIGHT_PX / height);
    return {
        width: Math.max(1, Math.round(width * scale)),
        height: Math.max(1, Math.round(height * scale)),
    };
}

export function formatVideoDuration(durationMs?: number): string {
    if (!durationMs || durationMs <= 0 || !Number.isFinite(durationMs)) return '';
    const totalSeconds = Math.round(durationMs / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    const pad = (value: number) => String(value).padStart(2, '0');
    return hours > 0 ? `${hours}:${pad(minutes)}:${pad(seconds)}` : `${minutes}:${pad(seconds)}`;
}

export function formatVideoSize(bytes?: number): string {
    if (!bytes || bytes <= 0) return '';
    if (bytes < 1024 * 1024) return `${Math.max(1, Math.round(bytes / 1024))} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
